export const CARD_ASPECT_W = 375
export const CARD_ASPECT_H = 245

// The aspect ratio of a card.
export const ASPECT_RATIO = CARD_ASPECT_W / CARD_ASPECT_H

// The background color of the "cover" card.
export const CARD_COVER_BG = '#f1f1f1'
